import React, { useState, useEffect, useCallback  } from "react";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";
import "../assets/CSS/Dashboard.css";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import "../Tickets/Tickets.css"; // Premium UI Styles

function AdminTicketManagement() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState({ fromDate: "", toDate: "", category: "" });
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  // const [remarksData, setRemarksData] = useState({});

  const [formData, setFormData] = useState({
    Category: "",
    Subject: "",
    Brief_Description: "",
    Supervisor_Name: "",
    Priority: "",
    Responsible: "", // New field
  });
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [toggleClearSelectedRows, setToggleClearSelectedRows] = useState(false);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  // Fetch Tickets
  const fetchTickets = async () => {
    try {
      const response = await axiosInstance.get("/api/ticketsAdmin");
      setTickets(response.data);
      setFilteredTickets(response.data);
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

 

  // ✅ Apply Filters (Search & Date Range & Category)
  const applyFilters = useCallback(() => {
    const { fromDate, toDate, category } = filters;

    const filtered = tickets.filter((ticket) => {
      const ticketDate = ticket.RaiseDate ? new Date(ticket.RaiseDate) : null;

      const matchesSearch =
        searchText === "" ||
        [
          ticket.ID,
          ticket.Category,
          ticket.Subject,
          ticket.Brief_Description,
          ticket.Supervisor_Name,
          ticket.Priority,
          ticket.Status,
        ]
          .join(" ")
          .toLowerCase()
          .includes(searchText.toLowerCase());

      const matchesCategory = category === "" || ticket.Category === category;

      const matchesDate =
        (!fromDate || (ticketDate && ticketDate >= new Date(fromDate))) &&
        (!toDate || (ticketDate && ticketDate <= new Date(toDate).setHours(23, 59, 59, 999)));

      return matchesSearch && matchesCategory && matchesDate;
    });

    // Sort tickets in descending order by ID (newest first)
    const sortedFiltered = filtered.sort((a, b) => b.ID - a.ID);

    setFilteredTickets(sortedFiltered);
  }, [tickets, filters, searchText]);



useEffect(() => {
  applyFilters();
}, [applyFilters]); // use applyFilters as a dependency


  const handleStatusChange = async (id, newStatus) => {
    try {
      await axiosInstance.patch(`/api/tickets/${id}`, { Status: newStatus });
      showAlert(`Status updated to "${newStatus}" successfully!`, "success");
      fetchTickets();
    } catch (error) {
      console.error("Error updating status:", error);
      showAlert("Failed to update status. Please try again!", "danger");
    }
  };

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 3000);
  };
    
  
  // Delete Ticket
  const handleDelete = async () => {
    if (selectedRows.length === 0) {
      alert("Please select a ticket to delete!");
      return;
    }
    const confirmDelete = window.confirm("Are you sure you want to delete the selected ticket?");
    if (!confirmDelete) return;

    try {
      const ticketId = selectedRows[0].ID;
      await axiosInstance.delete(`/api/tickets/${ticketId}`);
      alert("Ticket deleted successfully!");
      fetchTickets();
      setSelectedRows([]);
      setToggleClearSelectedRows(!toggleClearSelectedRows);
    } catch (error) {
      console.error("Error deleting ticket:", error);
      alert("Failed to delete ticket!");
    }
  };

  // Update Modal Logic
  const handleEdit = () => {
    if (selectedRows.length === 0) return alert("Select a ticket to update!");
    const ticketToEdit = selectedRows[0];
    setFormData({
      Category: ticketToEdit.Category,
      Subject: ticketToEdit.Subject,
      Brief_Description: ticketToEdit.Brief_Description,
      Supervisor_Name: ticketToEdit.Supervisor_Name,
      Priority: ticketToEdit.Priority,
    });
    setSelectedTicketId(ticketToEdit.ID);
    setShowModal(true);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.put(`/api/tickets/${selectedTicketId}`, formData);
      alert("Ticket updated successfully!");
      fetchTickets();
      setShowModal(false);
    } catch (error) {
      console.error("Error updating ticket:", error);
    }
  };

  // Reset Filters
  const resetFilters = () => {
    setSearchText("");
    setFilters({ fromDate: "", toDate: "" });
    fetchTickets();
    setFilteredTickets(tickets); 
  };

    // ✅ Format Date to 'YYYY-MM-DD HH:MM:SS' (IST)
    const formatDateTime = (date) => {
      if (!date) return "N/A"; // Handle undefined/null dates gracefully
  
      const dt = new Date(date);
      if (isNaN(dt)) return "Invalid Date"; // Avoid errors for invalid dates
  
      return dt.toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "Asia/Kolkata",
      }).replace(",", ""); // Ensure proper spacing
    };

    const handleRemarkUpdate = (id, newRemark) => {
      if (!id) return;
    
      // Ensure empty string is converted to null
      const updatedRemark = newRemark.trim() === "" ? null : newRemark;
    
      // Update the remark in local state (Optimistic UI)
      setTickets((prevTickets) =>
        prevTickets.map((ticket) =>
          ticket.ID === id ? { ...ticket, Remarks: updatedRemark } : ticket
        )
      );
    
      setFilteredTickets((prevFiltered) =>
        prevFiltered.map((ticket) =>
          ticket.ID === id ? { ...ticket, Remarks: updatedRemark } : ticket
        )
      );
    
      // Clear previous timeout to debounce API call
      clearTimeout(window.remarkTimeout);
      
      // Trigger API call after 800ms of inactivity
      window.remarkTimeout = setTimeout(async () => {
        try {
          await axiosInstance.patch(`/api/tickets_addRemark/${id}`, { Remarks: updatedRemark });
          showAlert("Remarks updated successfully!", "success");
        } catch (error) {
          console.error("Error updating remark:", error);
          showAlert("Failed to update remarks. Please try again!", "danger");
        }
      }, 800);
    };
    

      


  // Table Columns
  const columns = [
    { name: "T N", selector: (row) => row.ID, sortable: true, width: "70px" },
    { name: "Category", selector: (row) => (
      <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={`${row.Category}`}
      >
        {row.Category}
      </span>
    ), sortable: true, wrap: true },
    { name: "Responsible", selector: (row) => row.Responsible, sortable: true, wrap: true },
    {
      name: "Subject",
      selector: (row) => (
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={`${row.Subject}`}
        >
          {row.Subject}
        </span>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Brief Description",
      selector: (row) => (
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={`${row.Brief_Description}`}
        >
          {row.Brief_Description}
        </span>
      ),
      sortable: true,
      wrap: true,
      minWidth: "250px",
    },
    { name: "Supervisor Name", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={`${row.Supervisor_Name}`}
      >
        {row.Supervisor_Name}
      </span>
    ), sortable: true, wrap: true },
    { name: "Priority", selector: (row) => row.Priority, sortable: true, width: "100px" },
    {
      name: "Status", width: "150px",
      cell: (row) => (
        <select
          value={row.Status}
          onChange={(e) => handleStatusChange(row.ID, e.target.value)}
          className="form-select form-select-sm bg-info text-black"
          
        >
          <option value="Open">Open</option>
          <option value="In Progress">In Progress</option>
          <option value="Resolved">Resolved</option>
          {/* <option value="Closed">Closed</option>*/}
        </select>
      ),
    },
    {
      name: "Raise Date",
      selector: (row) => formatDateTime(row.RaiseDate),
      sortable: true,
      width: "150px",
    },
    {
      name: "Due Date",
      selector: (row) => formatDateTime(row.DueDate),
      sortable: true,
      width: "150px",
    },
    {
      name: "Add Remark",
      cell: (row) => (
        <textarea
          className="form-control"
          rows="1"
          value={row.Remarks || ""}
          onChange={(e) => handleRemarkUpdate(row.ID, e.target.value)}
          placeholder="Enter remark..."
          style={{ fontSize: "14px" }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
    },
    
    // { name: "Raise Date", selector: (row) =>(
    //   <span data-bs-toggle="tooltip" data-bs-placement="top" title={formatDateTime(row.RaiseDate)}>
    //     {formatDateTime(row.RaiseDate)}
    //     {/* //{row.RaiseDate} */}
    //   </span>
    // ), sortable: true },
  ];
  // const formatDateTime = (date) => {
  //   if (!date) return "N/A"; // Handle undefined/null dates gracefully
  //   const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  //   const timeOptions = {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true,
  //     timeZone: "Asia/Kolkata", // Use IST timezone
  //   };
  
  //   const formattedDate = new Date(date).toLocaleDateString("en-GB", options); // DD/MM/YYYY
  //   const formattedTime = new Date(date).toLocaleTimeString("en-IN", timeOptions); // hh:mm AM/PM
  
  //   return `${formattedDate} : ${formattedTime}`;
  // };
  // const formatDateTime = (date) => {
  //   if (!date) return "N/A"; // Handle undefined/null dates gracefully
  
  //   const dt = new Date(date);
  //   const options = { timeZone: "Asia/Kolkata" };
  
  //   const year = dt.toLocaleString("en-GB", { year: "numeric", ...options });
  //   const month = dt.toLocaleString("en-GB", { month: "2-digit", ...options });
  //   const day = dt.toLocaleString("en-GB", { day: "2-digit", ...options });
  //   const hours = dt.toLocaleString("en-GB", { hour: "2-digit", hour12: false, ...options }).padStart(2, "0");
  //   const minutes = dt.toLocaleString("en-GB", { minute: "2-digit", ...options }).padStart(2, "0");
  //   const seconds = dt.toLocaleString("en-GB", { second: "2-digit", ...options }).padStart(2, "0");
  
  //   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  // };
  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1 tickets-dashboard-container">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <div id="alertPlaceholder"></div>
        <main className="main-container p-4" style={{height:"-webkit-fill-available"}}>
          
          <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
            <h4 className="fw-bold text-secondary mb-0" style={{ letterSpacing: "0.5px" }}><i className="bi bi-shield-lock-fill me-2 text-primary"></i>Admin Ticket Management</h4>
            <div>
              <button className="btn btn-primary me-2" onClick={handleEdit} style={{display:"none"}}>
                Update Ticket
              </button>
              <button className="btn btn-outline-danger me-2" onClick={handleDelete} style={{display:"none"}}>
                 Delete Ticket
               </button>
              {/* <button className="btn btn-secondary" onClick={resetFilters}>
                Reload ⟳
              </button> */}
            </div>
          </div>

          <div className="card glass-card p-4 mb-4">
            <div className="row g-3 align-items-center justify-content-end">
              <div className="col-md-2">
                <select
                  name="category"
                  value={filters.category}
                  onChange={(e) => setFilters({ ...filters, category: e.target.value })}
                  className="form-select modern-input w-100"
                >
                  <option value="">All Categories</option>
                  {[...new Set(tickets.map(t => t.Category).filter(Boolean))].map((cat, idx) => (
                    <option key={idx} value={cat}>{cat}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control modern-input w-100"
                  placeholder="Search tickets..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <input
                  type="date"
                  className="form-control modern-input w-100"
                  value={filters.fromDate}
                  onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                  title="From Date"
                />
              </div>
              <div className="col-md-2">
                <input
                  type="date"
                  className="form-control modern-input w-100"
                  value={filters.toDate}
                  onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                  title="To Date"
                />
              </div>
              <div className="col-md-auto ms-auto">
                <button className="btn btn-outline-danger shadow-sm fw-semibold w-100" onClick={() => {
                  setSearchText("");
                  setFilters({ fromDate: "", toDate: "", category: "" });
                  fetchTickets();
                }}>
                  <i className="bi bi-arrow-counterclockwise me-1"></i>Reload
                </button>
              </div>
            </div>
          </div>

          <div className="modern-table-container">
            <DataTable
              customStyles={{
                headRow: {
                  style: {
                    backgroundColor: '#000000',
                    color: '#ffffff',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px',
                  },
                },
                headCells: {
                  style: {
                    color: '#ffffff',
                  },
                },
              }}
            columns={columns}
            data={filteredTickets}
            pagination
            // selectableRows
            highlightOnHover
            pointerOnHover
            onSelectedRowsChange={(state) => setSelectedRows(state.selectedRows)}
            clearSelectedRows={toggleClearSelectedRows}
            />
          </div>
        </main>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Update Ticket</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleFormSubmit}>
                <div className="modal-body">
                  <input type="text" name="Category" placeholder="Category" value={formData.Category} onChange={(e) => setFormData({ ...formData, Category: e.target.value })} className="form-control mb-2" />
                  <input type="text" name="Subject" placeholder="Subject" value={formData.Subject} onChange={(e) => setFormData({ ...formData, Subject: e.target.value })} className="form-control mb-2" />
                  <textarea name="Brief_Description" placeholder="Brief Description" value={formData.Brief_Description} onChange={(e) => setFormData({ ...formData, Brief_Description: e.target.value })} className="form-control mb-2" />
                  <input type="text" name="Supervisor_Name" placeholder="Supervisor Name" value={formData.Supervisor_Name} onChange={(e) => setFormData({ ...formData, Supervisor_Name: e.target.value })} className="form-control mb-2" />
                  <select name="Priority" value={formData.Priority} onChange={(e) => setFormData({ ...formData, Priority: e.target.value })} className="form-control mb-2">
                    <option value="">Select Priority</option>
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                  </select>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminTicketManagement;
